export { Share as default } from './Share';
